<template>
  <div>
    <avue-crud :option="option" :data="list.value" ref="crud" @refresh-change="refreshChange">
      <!-- 自定义搜索框 -->
      <template slot="mySearch">
        <div class="search-contain">
          <Search @exportExcel="exportOrder"></Search>
        </div>
      </template>

      <!-- 自定义表格列 -->
      <template #index="{ row }">
        <el-radio v-model="selectRow" :label="row.cdkeyConfigId">&nbsp;</el-radio>
      </template>
      <template #cdkeyConfigId="{ row }">
        <span style="color: #409EFF;cursor: pointer;" @click="toActiveGenerate(row.cdkeyConfigId)">{{ row.cdkeyConfigId
        }}</span>
      </template>

      <!-- 自定义表格操作栏 -->
      <!-- <template #menu="{ row }">
        <el-button type="text" size="small" @click="viewLog(row)">日志</el-button>
        <el-button type="text" size="small" @click="edit(row)">编辑</el-button>
        <el-button type="text" size="small" @click="del(row)">删除</el-button>
      </template> -->
    </avue-crud>
    <!-- 分页组件 -->
    <ElementPagination style="margin-bottom: 20px" :current-page="searchParams.current" :page-size="searchParams.size"
      :total="searchParams.total" :page-sizes="[10, 20, 30, 40, 50]" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" />
  </div>
</template>

<script>
import Search from "./Search.vue";
import ElementPagination from "@/components/ElementPagination";
import Message from "@/components/Message";
import { exportFinanceOrder } from '@/api/memberNew/activeList'
import moment from "moment";
export default {
  name: "WebSaaSTable",
  inject: ["currentTab", "list", "searchParams", "getList"],
  provide() {
    return {
      searchParams: this.searchParams,
      getList: this.getList,
    };
  },
  components: {
    Search,
    ElementPagination,
  },

  data() {
    return {
      /** 选择的批次id */
      selectRow: "",
      option: {
        lazy: true,
        tip: false,
        simplePage: true,
        searchShow: true,
        // searchMenuSpan: 6,
        tree: true,
        border: true,
        /** 表格索引 */
        index: false,
        /** 表格搜索显隐按钮 */
        searchShowBtn: true,
        /** 是否启用功能按钮 */
        searchIcon: true,
        searchIndex: 0,
        /** 表格查看按钮 */
        viewBtn: false,
        /** 表格新增按钮 */
        addBtn: false,
        /** 表格删除按钮 */
        delBtn: false,
        /** 表格修改按钮 */
        editBtn: false,
        /** 导出按钮 */
        excelBtn: false,
        /** 是否有选择框	 */
        selection: false,
        /** 表格高度 */
        height: 500,
        /** 是否有操作栏 */
        menu: false,
        /** 空数据时显示的文本内容 */
        emptyText: "-",
        /** 表格搜索按钮 */
        // searchBtn: false,
        /** 表格清空按钮 */
        // emptyBtn: false,
        /** 开启拖拽功能 */
        // sortable: true,
        // dragHandler: true,
        // rowSort: true,
        // columnSort: true,
        // menuWidth: 200,
        column: [

          {
            label: "ID",
            width: "60",
            prop: "id",
            // slot: true,
            /** 当内容过长被隐藏时显示 tooltip */
            overHidden: false,
            // search: true,
            columnBtn: false,
            /** 搜索项位置排序，序号越大越靠前 */
            // searchOrder: 1,
          },
          {
            label: "批次ID",
            width: "120",
            prop: "cdkeyConfigId",
            slot: true
          },
          {
            label: "激活码",
            width: "120",
            prop: "cdkey",
          },
          {
            label: "激活码名称",
            width: "120",
            prop: "name",
            overHidden: true,
          },
          {
            label: "状态",
            width: "120",
            prop: "status",
            dicData: [
              { label: "未激活", value: 0 },
              { label: "已激活", value: 1 },
              { label: "已冻结", value: 2 },
              { label: "已作废", value: 3 },
              { label: "已过期", value: 4 },
            ],
          },

          {
            label: "激活码过期时间",
            width: "160",
            prop: "expireTime",
            formatter: (row, column, cellValue) => {
              return cellValue || "-";
            },
          },
          {
            label: "激活时间",
            width: "160",
            prop: "redeemTime",
            formatter: (row, column, cellValue) => {
              return cellValue || "-";
            },
            /** 当内容过长被隐藏时显示 tooltip */
            overHidden: true,
          },
          {
            label: "激活手机号",
            width: "120",
            prop: "redeemMobile",
            formatter: (row, column, cellValue) => {
              return cellValue || "-";
            },
          },
          {
            label: "激活码生成时间",
            prop: "createTime",
            formatter: (row, column, cellValue) => {
              return cellValue || "-";
            },
            /** 当内容过长被隐藏时显示 tooltip */
            overHidden: true,
          },

          {
            label: "",
            prop: "my",
            hide: true,
            showColumn: false,
            search: true,
            display: false,
            menuClassName: "myClass",
            searchslot: true,
          },
        ],
      },

    };
  },

  methods: {
    toActiveGenerate(id) {
      this.$router.push({
        path: `/memberNew/activeCode/activeCodeGenerate?id=${id}`,
      });
    },
    /** 导出 */
    async exportOrder() {

      console.log("导出激活码");
      try {
        console.log("loadList", this.searchParams);
        if (this.searchParams.createTime) {
          this.searchParams.createStartDate = this.searchParams.createTime[0] || "";
          this.searchParams.createEndDate = this.searchParams.createTime[1] || "";
        } else {
          this.searchParams.createStartDate = "";
          this.searchParams.createEndDate = "";
        }
        if (this.searchParams.redeemTime) {
          this.searchParams.redeemStartDate = this.searchParams.redeemTime[0] || "";
          this.searchParams.redeemEndDate = this.searchParams.redeemTime[1] || "";
        } else {
          this.searchParams.redeemStartDate = "";
          this.searchParams.redeemEndDate = "";
        }
      } catch (error) {
        console.log("时间格式化错误");
        console.log(error);
      }
      const params = { ...this.searchParams }
      delete params.createTime;
      delete params.redeemTime;
      console.log("导出激活码", params);
      const res = await exportFinanceOrder(params);
      const blob = new Blob([res.data]);
      console.log("导出的响应", res);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      // 设置下载文件的名称和扩展名
      a.download = decodeURIComponent(
        "激活码财务订单记录_" + moment().format("YYYY-MM-DD") + ".xlsx"
      );
      document.body.appendChild(a);
      a.click();
      // 释放URL对象
      window.URL.revokeObjectURL(url);

    },
    //^ ^--------------分页相关-------------^ ^
    /** 刷新 */
    refreshChange() {
      Message.success('刷新成功')
      this.getList();
    },
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val;
      Message.success(`每页 ${val} 条`);
      /** 更新数据 */
      this.getList();
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      Message.success(`当前页 ${val}`);
      /** 更新数据 */
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.auditOpinion {
  ::v-deep .el-input__inner {
    text-align: center;
    width: 300px;
  }
}

::v-deep .avue-crud__pagination {
  display: none !important;
}

::v-deep .avue-form__group {
  .el-col {
    padding: 0px !important;
    margin: 0px !important;
  }
}

.avue-crud .avue-input-number,
.avue-crud .el-cascader,
.avue-crud .el-date-editor.el-input,
.avue-crud .el-date-editor.el-input__inner,
.avue-crud .el-select,
.avue-form .avue-input-number,
.avue-form .el-cascader,
.avue-form .el-date-editor.el-input,
.avue-form .el-date-editor.el-input__inner,
.avue-form .el-select {
  width: 70% !important;
}

::v-deep .avue-form__menu--center {
  display: none !important;
}

::v-deep .avue-form__group .el-col-md-6 {
  width: 100%;
}

::v-deep .avue-form__group .el-form-item__content {
  margin-left: 0px !important;
}

::v-deep .avue-crud .avue-crud__search .avue-form .avue-form__group .avue-form__row .el-form-item label {
  float: none;
  display: inline-block;
  width: 100%;
}
</style>